import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { Input } from '@mui/material';

export default function ExamVerification() {
  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }
  const tableRef = useRef(null);

  const collegename = localStorage.getItem('username');

  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [checkExamexist, setCheckExamexist] = useState([]);
  const [qpdwnmsgView, setQpdwnmsgView] = useState([]);

  const [loading, setlodaing] = useState(false);

  const [examid, setExamIdData] = useState('');
  //const [getexamData, setExamData] = useState([]);
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [responseMessage, setResponseMessage] = useState(null);
  const [maskedContact, setMaskedContact] = useState('');


  const { http } = Api();

  useEffect(() => {
    const fetchMaskedContact = async () => {
      try {
        const response = await http.get('/College/getCollegeMaskedContact');
        if (response.data) {
          setMaskedContact(response.data.principal_email_for_qp); // Adjust based on actual response structure
        } else {
          toast.error("Failed to load masked contact.");
        }
      } catch (error) {
        toast.error("Error fetching masked contact.");
      }
    };

    fetchMaskedContact();
  }, []); // Empty dependency array to run only on page load

  // const handlExamChange = (selectedOption) => {
  //   setExamIdData(selectedOption.value);
  // };
  // useEffect(() => {
  //   const fetchExamData = async () => {
  //     try {
  //       const response = await http.get(`College/getActiveExams`);

  //       // console.log("response", response.data);
  //       setExamData(response.data);
  //     }
  //     catch (error) {
  //       if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
  //         toast.error("Invalid Token");
  //         setTimeout(() => {
  //           navigate("/college/");
  //         }, 5000);

  //       }
  //       else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
  //         toast.error(error.response.data.message);
  //       }
  //       else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
  //         toast.error("No active exam found");
  //       }
  //       else {
  //         toast.error("Something went wrong");
  //       }
  //     }
  //   };

  //   fetchExamData();
  // }, []);


  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    const fetchData = async () => {
      //alert(examid);
      try {
        const response = await http.get(`/College/checkQuestionpaperdwnexamexist`);

        const { checkExamexist, qpdwnmsgView } = response.data;

        setCheckExamexist(checkExamexist);
        setQpdwnmsgView(qpdwnmsgView);
        //setLoading(false);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, []);


  const handleVerify = async () => {

    try {
      const response = await http.get('/College/Questionpaperdwnlogin', {
        params: {
          dwnqpopt: otp,
          pssqpdwn: password
        }
      });
      console.log("responseq=", response);
      if (response.data.status_code == "MSG12" || response.data.http_status == 200) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/college/questionpaperdownloadpage");
        }, 2000);

      }
      else if (response.data.status_code === "ERR38") {
        toast.error(response.data.message);
      } else {
        // Handle unexpected status codes
        toast.error("Unexpected error occurred.");
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Verification failed";
      toast.error(errorMessage);
    }
  };



  const handleResendOtp = async () => {
    try {
      const response = await http.post('/College/Resendotpqpdwn');
      if (response.data.status_code == "MSG12" || response.data.http_status == 200) {  //&& response.data.status_code === "MSG12"
        toast.success(response.data.message);
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Resend OTP failed";
      toast.error(errorMessage);
    }
  };


  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="my-page">

            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Download Question Paper</h5>
                        </div>

                      </div>
                      <div className="card-body">


                        <div className="container">
                          <div className="row mb-4 hed-bak">
                            <div className="alert alert-light-info light alert-dismissible fade show text-dark border-left-wrapper" role="alert">
                            <div className="col-md-6">
                            <h6 className="hed-fnt-wt"> <i className="fa fa-phone" aria-hidden="true"></i> Exclusive QP support: 0481 2733407</h6>
                            </div>
                            <div className="col-md-6">
                            <h6 className="hed-fnt-wt" style={{ textAlign: 'right' }}> <i className="fa fa-envelope" aria-hidden="true"></i>  Email: qp@mgu.ac.in</h6>
                            </div>
                            </div>
                          </div>
                          {checkExamexist && checkExamexist.length > 0 ? (
                            <>
                              <div className="row mb-3">
                                <div className="col-md-4">
                                  <label htmlFor="otp"> OTP <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control input-air-primary"
                                    type="text"
                                    id="otp"
                                    name="otp"
                                    placeholder="OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                  />
                                   <p style={{textAlign:'center',fontSize:'12px'}}>(OTP received in {maskedContact})</p> 
                                </div>
                                <div className="col-md-4">
                                <button className="btn btn-outline-success" type="button" onClick={handleResendOtp} style={{ width: '140px' }}>Resend OTP</button>

                                </div>
                              </div>
                              <div className="row mb-3">
                                <div className="col-md-4">
                                  <label htmlFor="course_code">Enter Password <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control input-air-primary"
                                    type="password"
                                    id="course_code"
                                    name="course_code"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="row mb-3">
                                <div className="col-md-12 txt-aln">

                                  <button className="btn btn-primary me-3" type="submit" onClick={handleVerify} style={{ width: '140px' }}>Verify</button>
                                  <input className="btn btn-outline-secondary" type="reset" value="Cancel"
                                    onClick={() => {
                                      setOtp('');
                                      setPassword('');
                                    }} style={{ width: '140px' }} />

                                </div>
                              </div>
                            </>
                          ) : (
                            qpdwnmsgView && qpdwnmsgView.length > 0 ? (

                              <div>
                                {qpdwnmsgView
                                  .map(item => item.msg)  // Extracting only the message text
                                  .filter((value, index, self) => self.indexOf(value) === index)  // Filter out duplicates
                                  .map((msg, index) => (
                                    // <p className="txt-aln" key={index}>{msg}</p>
                                    <h6 style={{ color: 'red' }} className="txt-aln" key={index} >{msg}</h6>

                                  ))}
                              </div>
                            ) : (
                              // <p className="txt-aln">No Data Found</p>
                              <h6 style={{ color: 'red' }} className="txt-aln">No Data Found</h6>

                            )
                          )}
                        </div>





                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
